import { DataVizContainerViewConfigWithoutStateManager } from '../../../common/types';
import {
  KpiFactboxTwoMetricVizData,
  KpiFactboxTwoMetricVizExternalProps,
} from '../../types';
import { twoColumnFactboxDataToUiComponentProps } from './dataToUiComponentProps';
import { KpiTwoColumnUiComponentProps } from './types';
import { KpiTwoColumnUiComponent } from './UiComponent';

export const twoColumnFactboxViewConfig: DataVizContainerViewConfigWithoutStateManager<
  KpiFactboxTwoMetricVizData,
  KpiFactboxTwoMetricVizExternalProps,
  KpiTwoColumnUiComponentProps
> = {
  hasStateManager: false,
  dataToUiComponentProps: twoColumnFactboxDataToUiComponentProps,
  UiComponent: KpiTwoColumnUiComponent,
};
